import { render, staticRenderFns } from "./InvitationNotifications.vue?vue&type=template&id=b3e32692&scoped=true&"
import script from "./InvitationNotifications.vue?vue&type=script&lang=js&"
export * from "./InvitationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./InvitationNotifications.vue?vue&type=style&index=0&id=b3e32692&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e32692",
  null
  
)

export default component.exports